import axios from 'axios';
import qs from 'qs';

const instance = axios.create({
  timeout: 300000,
});

function Cache(ttl) {
  let me = this;

  me.now = function() { return (new Date()).getTime() };
  me.ttl = ttl || 0;
  me.data = {};

  me.get = function(key) {
    let val = null;
    let obj = me.data[key];
    if(obj) {
      val = obj.val;
      if(me.now() >= obj.expires) {
        val = null;
        delete me.data[key]
      }
    }
    return val
  };

  me.del = function(key) {
    let oldval = me.get(key);
    delete me.data[key];
    return oldval
  };

  me.put = function(key, val, ttl) {
    if(ttl === undefined) {
      ttl = me.ttl;
    }
    let oldval = me.del(key);
    if(val !== null)
      me.data[ key ] = { expires: me.now() + ttl, val: val };
    return oldval
  }
}

let cache = new Cache(5 * 1000);

export function httpCache(key, action, ttl) {
  if (typeof key === 'object')
    key = JSON.stringify(key, function(key, value) { return value == null ? undefined : value; });

  let value = cache.get(key);
  if (value) return value;

  value = action();
  cache.put(key, value, ttl);

  return value;
}


const paramsSerializer = p => qs.stringify(p, {indices: false, allowDots: true});

export async function httpGet(url, params, {authToken, noCache = false} = {}) {
  let options = {params: params, paramsSerializer};
  if (noCache) options.headers = {...options.headers, 'Pragma': 'no-cache'};
  if (authToken) options.headers = {...options.headers, 'Authorization': 'Bearer ' + authToken};

  return (await instance.get(url, options)).data;
}

export async function httpPut(url, body) {
  return (await instance.put(url, body)).data;
}

export async function httpPost(url, body, {headers, withCredentials, ttl} = {}) {
  let data = await httpCache(
    {url, body},
    () => instance.post(url, body, {headers, withCredentials, mode: 'no-cors',}).then(a => a && a.data || null),
    ttl);

  return data;
}

export async function httpPath(url, body, headers) {
  return (await instance.patch(url, body, {headers})).data;
}

export async function httpDelete(url, params, headers) {
  return (await instance.delete(url, {params: params, paramsSerializer, headers})).data;
}

export function urlConcat(url, relativeUri, {autoSlash = true} = {}) {
  if (autoSlash && relativeUri && url) {
    if (relativeUri[0] !== '/' && url[url.length - 1] !== '/')
      relativeUri = "/" + relativeUri;
    else if (relativeUri[0] === '/' && url[url.length - 1] === '/')
      relativeUri = relativeUri.substring(1);
  }

  let fullUrl = url + relativeUri;
  return fullUrl;
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// ВАЖНО! данный метод возвращает НЕ Promise
// не подходит для отработки длинных цепочек then/catch
// и преднозначен для простой обработки ответа

// обработчик вызывается только для последнего отправленного запроса
export function httpDebounce(request) {
  let key = uuidv4();

  return function (a1, a2, a3, a4, a5, a6, a7, a8, a9) {
    let requestId = uuidv4();
    key = requestId;

    let prms = request(a1, a2, a3, a4, a5, a6, a7, a8, a9);

    let callback = {
      payload: null,
      state: null,
      id: requestId,

      t: null,
      then: function (t) {
        const {state, id, payload} = this;
        if (state === 'then' && id === key) t(payload);

        this.t = t;
        return this;
      },
      c: null,
      catch: function (c) {
        const {state, id, payload} = this;
        if (state === 'catch' && id === key) c(payload);

        this.c = c;
        return this;
      },
      f: null,
      finally: function (f) {
        const {state, id} = this;
        if (state && id === key) f();

        this.f = f;
        return this;
      },
    };


    if (prms) {
      prms.then(data => {
        callback.state = 'then';
        callback.payload = data;

        if (key === requestId) {
          if (callback.t) callback.t(data);
        }
      }).catch(e => {
        callback.state = 'catch';
        callback.payload = e;

        if (key === requestId) {
          if (callback.c) callback.c(e);
        }
      }).finally(() => {
        if (key === requestId) {
          if (callback.f) callback.f();
        }
      });
    }

    return callback;
  };
}
